import { DeleteOutlined, EditOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Flex, Modal, Spin, Tooltip, Typography } from "antd";
import { useForm } from "antd/lib/form/Form";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useGetDataOnScroll } from "../../../../components/getDataOnScrollProps/useGetDataOnScrollProps";
import { useTheNeedsOfThePopulation } from "./UsetheNeedsOfThePopulation";
import i18n from "i18next";
import _ from "lodash";
import { EntTheNeedsOfThePopulation } from "../../../../models/organic/theNeedsOfThePopulation";
import { EntTheNeedsOfThePopulationFilter } from "../../../../models/filters/organic/theNeedsOfThePopulationFilter";
import { useLazyGetTheNeedsOfThePopulationListQuery } from "../../../../redux/api/organic/theNeedsOfThePopulationApi";
import { EmptyData } from "../../../../components/empty/emptyData";
import { PageHeader } from "../../../../components/page-header";
import { ContentPartFilter } from "../../../../components/content-part/ContentPartFilter";
import { FilterTheNeedsOfThePopulation } from "./FiltertheNeedsOfThePopulation";
import { AddTheNeedsOfThePopulationModal } from "./addtheNeedsOfThePopulation";

enum FormField {
  year,
  regionId,
  areaId,
  territorialUnitId,
  productTypeId
}

export const TheNeedsOfThePopulation = () => {
  const [modal, contextHolder] = Modal.useModal();
  const [selectedItem, setSelectedItem] = useState<EntTheNeedsOfThePopulation>(new EntTheNeedsOfThePopulation());
  const [showModal, setShowModal] = useState<boolean>(false);
  const [showReportModal, setShowReportModal] = useState<boolean>(false);
  const [form] = useForm();
  const { t } = useTranslation()

  const [getArchiveFolders] = useLazyGetTheNeedsOfThePopulationListQuery();
  const {
	filter,
	fetching,
	data,
	access,
	totalItems,
	setData,
	setFetching,
	setFilter,
	scrollHandler,
	setCurrentPage
  } = useGetDataOnScroll<EntTheNeedsOfThePopulation, EntTheNeedsOfThePopulationFilter>({
	initialFilter: new EntTheNeedsOfThePopulationFilter(),
	query: getArchiveFolders
  });

  const {
	onAddTheNeedsOfThePopulation,
	onDeleteTheNeedsOfThePopulation,
	onEditTheNeedsOfThePopulation
  } = useTheNeedsOfThePopulation(modal, () => {
	searchHandleClick();
  })
  const [height, setHeight] = useState<number>(0);

  const storedData = JSON.parse(localStorage.getItem("availableRoutes") || "[]");
  const isReportAvailable = storedData.some((route: any) => (route.alias === "/report" || route.alias === "/interactive-map-ws") && route.methodPost);

  const openAddModal = (item: EntTheNeedsOfThePopulation) => {
	setSelectedItem(item);
	setShowModal(true);
  }

  const setEntityFromFields = (): EntTheNeedsOfThePopulationFilter => {
	let filt: EntTheNeedsOfThePopulationFilter = _.clone(filter);
	
	// Добавляем поля только если они имеют значения
	const year = form.getFieldValue(FormField.year);
	const regionId = form.getFieldValue(FormField.regionId);
	const areaId = form.getFieldValue(FormField.areaId);
	const territorialUnitId = form.getFieldValue(FormField.territorialUnitId);
	const productTypeId = form.getFieldValue(FormField.productTypeId);
	
	if (year) filt.year = year;
	if (regionId) filt.regionId = regionId;
	if (areaId) filt.areaId = areaId;
	if (territorialUnitId) filt.territorialUnitId = territorialUnitId;
	if (productTypeId) filt.productTypeId = productTypeId;
	
	filt.page = 1;
	return filt;
  }

  const clearFields = () => {
	form.setFields([
	  { name: FormField.year, value: null },
	  { name: FormField.regionId, value: null },
	  { name: FormField.areaId, value: null },
	  { name: FormField.territorialUnitId, value: null },
	  { name: FormField.productTypeId, value: null },
	]);
  }

  const searchHandleClick = () => {
	setFilter(setEntityFromFields());
	setData([]);
	setCurrentPage(0);
	setFetching(true);
  }

  const table = (
	<div style={ { maxHeight: `${ height }px`, overflow: 'auto' } } onScroll={ scrollHandler }>
	  <table>
		<thead>
		<tr>
		  <th style={ { width: "40px" } }>#</th>
		  <th>{ t('Год') }</th>
		  <th>{ t('Регион') }</th>
		  <th>{ t('Район') }</th>
		  <th>{ t('Территориальная единица') }</th>
		  <th>{ t('Тип продукта') }</th>
		  <th>{ t('Население') }</th>
		  <th>{ t('Среднее потребление') }</th>
		  <th>{ t('Общее потребление (тонн)') }</th>
		  <th style={ { width: "120px" } }></th>
		</tr>
		</thead>
		<tbody>
		{ fetching ? (
		  <tr>
			<th colSpan={ 10 }>
			  <Spin spinning={ fetching } style={ {
				width: '100%',
				height: '180px',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center'
			  } }/>
			</th>
		  </tr>
		) : null }
		{ data.length !== 0 ? data.map((item, index) => (
		  <tr key={ item.id }>
			<td>{ ++index }</td>
			<td>{ item.year }</td>
			<td>{ i18n.language === 'ru' ? item.region?.nameRu : item.region?.nameKy }</td>
			<td>{ i18n.language === 'ru' ? item.area?.nameRu : item.area?.nameKy }</td>
			<td>{ i18n.language === 'ru' ? item.territorialUnit?.nameRu : item.territorialUnit?.nameKy }</td>
			<td>{ i18n.language === 'ru' ? item.productType?.nameRu : item.productType?.nameKy }</td>
			<td>{ item.population?.toLocaleString() }</td>
			<td>{ item.averageConsumption }</td>
			<td>{ item.totalConsumptionTonnes?.toLocaleString() }</td>
			<td>
			  <Flex gap="small">
				{ access && access.methodPut && (
				  <Tooltip title={ t('general.edit') }>
					<Button className='btn_edit' onClick={ () => {
					  openAddModal(item)
					} } type="primary" shape="circle" icon={ <EditOutlined/> }/>
				  </Tooltip>
				) }
				{ access && access.methodDelete && (
				  <Tooltip title={ t('general.delete') }>
					<Button className='btn_edit' danger onClick={ () => {
					  onDeleteTheNeedsOfThePopulation(item)
					} } type="primary" shape="circle" icon={ <DeleteOutlined/> }/>
				  </Tooltip>
				) }
			  </Flex>
			</td>
		  </tr>
		)) : (
		  <tr>
			<td colSpan={ 10 }>
			  <EmptyData/>
			</td>
		  </tr>
		) }
		</tbody>
	  </table>
	</div>
  );

  return (
	<>
	  <PageHeader
		title={ t('Потребности населения') }
		additionalInfo={
		  <Typography.Text style={ { marginBottom: '0.5em', display: 'block' } } type="secondary">
			{ t('general.records_found') } { totalItems }
		  </Typography.Text>
		}
	  />
	  { access && access.methodPost && (
		<Button type="primary" icon={ <PlusOutlined/> } onClick={ () => {
		  openAddModal(new EntTheNeedsOfThePopulation())
		} }>
		  { t('general.add') }
		</Button>
	  ) }
	  <ContentPartFilter
		filter={ <FilterTheNeedsOfThePopulation
		  onSearch={ searchHandleClick }
		  onReset={ () => {
			clearFields();
			searchHandleClick()
		  } }
		  formField={ FormField }
		  form={ form }
		/> }
		setHeight={ setHeight }
		table={ table }
	  />

	  <AddTheNeedsOfThePopulationModal
		item={ selectedItem }
		show={ showModal }
		onHide={ () => {
		  setShowModal(false)
		} }
		onSubmit={ selectedItem.id !== null ? onEditTheNeedsOfThePopulation : onAddTheNeedsOfThePopulation }
	  />
	  { contextHolder }
	</>
  );
}
